"use strict";

import './style.css';
import './legal.css';

import * as optionpanel from './optionpanel.js';

(async()=>
	{
	await optionpanel.ValidateLogin();
	optionpanel.MenuState(true);

	const renderPageID=document.getElementById('renderpage');
	if (renderPageID) renderPageID.style.visibility='visible';
	})();
